import { getCurrentLanguage } from '../../../helpers/LangHelper';
import { MenuProductTypes } from '../../constants/ProductTypes';

type UrlByLanguage = Record<string, Record<MenuProductTypes, string>>;

export const getUrlByLanguage = (type: MenuProductTypes): string => {
    const lang = getCurrentLanguage();

    const urlByLanguage: UrlByLanguage = {
        es: {
            advanced_signature: 'https://www.signaturit.com/es/e-signature/avanzada/',
            simple_signature: 'https://www.signaturit.com/es/e-signature/simple/',
            certified_email: 'https://www.signaturit.com/es/productos/comunicaciones-certificadas/email/',
            certified_sms: 'https://www.signaturit.com/es/productos/comunicaciones-certificadas/sms/',
        },
        en: {
            advanced_signature: 'https://www.signaturit.com/e-signature/advanced/',
            simple_signature: 'https://www.signaturit.com/e-signature/simple/',
            certified_email: 'https://www.signaturit.com/products/certified-comunications/email/',
            certified_sms: 'https://www.signaturit.com/products/certified-comunications/sms/',
        },
        fr: {
            advanced_signature: 'https://www.signaturit.com/fr/e-signature/avancee/',
            simple_signature: 'https://www.signaturit.com/fr/e-signature/simple/',
            certified_email: 'https://www.signaturit.com/fr/produits/communication-certifiee/email/',
            certified_sms: 'https://www.signaturit.com/fr/produits/communication-certifiee/sms/',
        },
    };

    return urlByLanguage[lang][type];
};

export const openInNewTab = (link: string): void => {
    window.open(link, '_blank')?.focus();
};

export const openInSameTab = (link: string): void => {
    window.open(link, '_self');
};
